'use strict';

import 'document-register-element';
import Draggable from 'gsap/Draggable';
import {prefixedCSSValue} from '../utils';
import resizeStore from '../resize/resize.store';


const grabbing = prefixedCSSValue('cursor', 'grabbing');
const grab = prefixedCSSValue('cursor', 'grab');


class GeographySlider extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._boundsWidth = 0;
    this._width = 0;

    this.handleResize = () => this._onResize();
  }
  connectedCallback() {
    this._dragWrapper = this.querySelector('.cs-drag');
    this._dragBounds = this.querySelector('.cs-bounds');
    this._slides = this.querySelectorAll('.h6');

    let s = 0;
    const snapping = Array.from(this._slides).map(slide => {
      let f = s;
      s = s - slide.offsetWidth - 46;
      return f;
    });

    const dragParams = {
      cursor: grab,
      activeCursor: grabbing,
      throwProps: true,
      type: 'x',
      bounds: this._dragBounds,
      snap: snapping,
      onPress: () => this.classList.add('touch'),
      onRelease: () => this.classList.remove('touch')
    };

    const controls = this.querySelector('.cs-controls');
    if (controls) {
      const prevButton = controls.querySelector('.cs-prev');
      const nextButton = controls.querySelector('.cs-next');
      const line = controls.querySelector('.cs-line span');

      const onUpdate = () => {
        const c = this._dragWrapper._gsTransform.x / (this._width - this._boundsWidth);

        // if (c === 0) {
        //   prevButton.classList.add('disable');
        // } else if (c === 1) {
        //   nextButton.classList.add('disable')
        // }

        TweenLite.set(line, {
          scaleX: -c
        });
      };
      const onClick = (newPos = 0) => {
        for (let i = 0; snapping.length > i; i++) {
          if (snapping[i] <= newPos) {
            newPos = snapping[i];
            break;
          }
        }

        TweenLite.to(this._dragWrapper, 0.5, {
          x: newPos,
          onUpdate: onUpdate,
          onComplete: () => {
            this._draggable.update();
          }
        });
      };

      prevButton.addEventListener('click', () => {
        if (this._dragWrapper._gsTransform.x === 0) return;

        const newPos = Math.min(this._dragWrapper._gsTransform.x + this._boundsWidth, 0);
        onClick(newPos);
      });
      nextButton.addEventListener('click', () => {
        const max = this._boundsWidth - this._width;
        if (this._dragWrapper._gsTransform.x <= max) return;

        const newPos = Math.max(this._dragWrapper._gsTransform.x - this._boundsWidth, max);
        onClick(newPos);
      });

      dragParams.onDrag = dragParams.onThrowUpdate = onUpdate;
    }

    this._draggable = Draggable.create(this._dragWrapper, dragParams)[0];

    this._onResize();
    resizeStore.eventEmitter.subscribe(this.handleResize);
  }
  disconnectedCallback() {
    this._draggable.kill();
    resizeStore.eventEmitter.unsubscribe(this.handleResize);
  }

  _onResize() {
    this._boundsWidth = this._dragBounds.offsetWidth;
    this._width = this._dragWrapper.offsetWidth;
  }
}

window.customElements.define('category-slider', GeographySlider);